module.exports = __webpack_public_path__ + "static/pl-3e3e1540d9437b70b6f27f9236b541d3.mp4";